import { render } from "./Home.vue?vue&type=template&id=5765bbea&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=5765bbea&scoped=true&lang=css"

import exportComponent from "C:\\development\\ON\\montalvo.ti\\dish-frontend-web-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5765bbea"]])

export default __exports__